// extracted by mini-css-extract-plugin
export default {"s-radio":"customRadio_s-radio__5I8s2","label":"customRadio_label__RMWva"};